<template lang="pug">
#botoes-de-acoes-rastreabilidade.view-container
    .botoes-container
        BaseButton.button-outline(
            icon='mdi mdi-tray-arrow-down',
            style='justify-content=space-between',
            @click='btnBaixarModelo()'
        )
            el-span.botao-texto Exportar Modelo CSV
        
        BaseButton(
            type='primary',
            icon='mdi mdi-tray-arrow-up',
            @click='btnInserir()'
        )
            el-span.botao-texto {{ btnPlaceHolder }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'BotoesDeAcoesRastreabilidade',
    components: {
        BaseButton
    },
    emits: ['btnInserirClicado', 'btnBaixarModeloClicado'],
    props: {
        btnPlaceHolder: {
            type: String,
            default: () => ''
        },
        inserirArquivo: {
            type: Function,
            default: () => false
        }
    },
    methods: {
        btnInserir() {
            this.$emit('btnInserirClicado');
        },
        btnBaixarModelo() {
            this.$emit('btnBaixarModeloClicado');
        }
    }
};
</script>

<style lang="scss" scoped>

.botoes-container {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    padding-top: 20px;
}

.botao-texto {
    padding-left: 5px;
}

</style>
